import LocalizedStrings from "react-localization";

const strings = new LocalizedStrings({
  en: {
    appTitle: "SmartConsole Extension Developer Guide"
  }
});

export function getStringOrDefault(key, defaultString) {
  let str = strings.getString(key);
  if (str != null) {
    return str;
  }

  return defaultString;
}
